<template>
  <div>
    <b-row>
      <b-col cols="12" class="mt-1">
        <div class="d-flex justify-content-end">
          <b-button variant="primary" class="my-1" @click="createPO()">
            Create Purchase Order
          </b-button>
        </div>
      </b-col>

      <b-col  cols="12"  md="2" sm="2" class="my-1">
        <b-form-group class="mb-0">
          <label class="d-inline-block text-sm-left mr-50">Per page</label>
          <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" />
        </b-form-group>
      </b-col>
      <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
      <b-button variant="outline-danger"  @click="clearFilters">
        Clear Filters
      </b-button>
    </b-col>
    </b-row>
   

    <b-row>
      <b-col cols="12">
        <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="filteredData"
          :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
          :filter="filter" @filtered="onFiltered">

          <<template #head(itemName)>
            <div class="d-flex flex-column">
              <span>Item Name</span>
              <b-form-input v-model="filters.itemName" placeholder="Filter by Item Name" size="sm"
                @input="filterTable" />
            </div>
</template>
<template #head(type)>
  <div class="d-flex flex-column">
    <span>Item Type</span>
    <b-form-select v-model="filters.type" :options="typeOptions" size="sm" @change="filterTable" />
  </div>
</template>
<template #head(supplierName)>
  <div class="d-flex flex-column">
    <span>Preferred Supplier</span>
    <b-form-input v-model="filters.supplierName" placeholder="Filter by Supplier" size="sm" @input="filterTable" />
  </div>
</template>
<template #head(categoryName)>
  <div class="d-flex flex-column">
    <span>Category</span>
    <b-form-input v-model="filters.categoryName" placeholder="Filter by Category" size="sm" @input="filterTable" />
  </div>
</template>
<template #head(subCategoryName)>
  <div class="d-flex flex-column">
    <span>Sub Category</span>
    <b-form-input v-model="filters.subCategoryName" placeholder="Filter by Sub Category" size="sm"
      @input="filterTable" />
  </div>
</template>
<template #head(lowStockValue)>
  <div class="d-flex flex-column">
    <span>Low Stock</span>
    <b-form-input v-model="filters.lowStockValue" placeholder="Filter by Low Stock" size="sm" @input="filterTable" />
  </div>
</template>
<template #head(currentStock)>
  <div class="d-flex flex-column">
    <span>Current Stock</span>
    <b-form-input v-model="filters.currentStock" placeholder="Filter by Current Stock" size="sm" @input="filterTable" />
  </div>
</template>

<template #cell(checkbox)="data">
  <b-form-checkbox :value="data.item.itemId" @change="handleCheckboxChange(data.item.itemId)">
  </b-form-checkbox>
</template>

<template #cell(itemName)="data">
  {{ data.item.itemName }}
</template>
<template #cell(type)="data">
  <b-badge v-if="data.item.type === 1" variant="primary">
    Finished Product
  </b-badge>
  <b-badge v-if="data.item.type === 2" variant="info">
    Semi Finished Product
  </b-badge>
  <b-badge v-if="data.item.type === 3" variant="secondary">
    Raw Material
  </b-badge>
</template>
</b-table>
<div class="d-flex justify-content-center mb-1">
  <b-alert variant="warning" show v-if="!filterResults" class="d-flex justify-content-center">
    <h4 class="alert-heading">No items found</h4>
  </b-alert>
</div>

<!-- Checkbox column for item selection -->
<template #cell(checkbox)="data">
  <b-form-checkbox :value="data.item.itemId" @change="handleCheckboxChange(data.item.itemId)">
  </b-form-checkbox>
</template>

<!-- No items alert -->
<b-alert class="d-flex justify-content-center" variant="warning" show v-if="!filteredData.length">No items
  found</b-alert>


<div class="d-flex justify-content-center mb-1">
  <b-spinner variant="success" label="Spinning" block v-if="loading" style="width: 3rem; height: 3rem"></b-spinner>
</div>
</b-col>
</b-row>

<b-row>
  <b-col cols="12">
    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
      class="my-0" />
      <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
  </b-col>
</b-row>
</div>
</template>

<script>
import supplier from "@/router/routes/supplier";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BSpinner,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BAlert,
} from "bootstrap-vue";

import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BAlert,
  },
  data() {
    return {
      itemData: [],
      filteredData: [],
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      filters: {
        itemName: "",
        type: "",
        supplierName: "",
        categoryName: "",
        subCategoryName: "",
        lowStockValue: "",
        currentStock: ""
      },
      typeOptions: [
        { value: "", text: "All" },
        { value: 1, text: "Finished Product" },
        { value: 2, text: "Semi Finished Product" },
        { value: 3, text: "Raw Material" }
      ],
      fields: [
        { key: "checkbox", label: "" },
        { key: "itemName", label: "Item Name", sortable: true },
        { key: "type", label: "Item Type", sortable: true },
        {
          key: "supplierName",
          label: "Preferred Supplier",
          sortable: true
        },
        { key: "categoryName", label: "Category", sortable: true },
        { key: "subCategoryName", label: "Sub Category", sortable: true },
        { key: "lowStockValue", label: "Low Stock", sortable: true },
        { key: "currentStock", label: "Current Stock", sortable: true },
      ],
      selectedItemIds: [],
      categories: [],
      subcategories: [],
      prefsuppliers: [],
      selectedCategory: "",
      selectedSubCategory: "",
      selectedSupplier: "",
      filterResults: true,
    };
  },

  computed: {

    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    ...mapGetters("notificationModule", {
      notification: "notification",
      loading: "loading",
    }),
    ...mapGetters("itemModule", {
      loading: "loading",
    }),
    ...mapGetters("productModule", {
      productList: "product",
      loading: "loading",
    }),
    ...mapGetters("rawmaterialModule", {
      rawmaterials: "rawmaterials",
      loading: "loading",
    }),
  },

  methods: {
    filterTable() {
      // Apply filtering logic
      this.filteredData = this.itemData.filter((item) => {
        return (
          // Filter by Item Name
          (this.filters.itemName === "" || item.itemName?.toLowerCase().includes(this.filters.itemName.toLowerCase())) &&
          // Filter by Item Type
          (this.filters.type === "" || item.type === parseInt(this.filters.type)) &&
          // Filter by Preferred Supplier
          (this.filters.supplierName === "" || item.supplierName?.toLowerCase().includes(this.filters.supplierName.toLowerCase())) &&
          // Filter by Category using getCategory
          (this.filters.categoryName === "" || item.categoryName?.toLowerCase().includes(this.filters.categoryName.toLowerCase())) &&
          // Filter by Sub Category using getSubCategory
          (this.filters.subCategoryName === "" || item.subCategoryName?.toLowerCase().includes(this.filters.subCategoryName.toLowerCase())) &&
          // Filter by Low Stock using getLowStock
          (this.filters.lowStockValue === "" || item.lowStockValue?.toString().includes(this.filters.lowStockValue)) &&
          // Filter by Current Stock (raw value assumed, add processing if needed)
          (this.filters.currentStock === "" || item.currentStock?.toString().includes(this.filters.currentStock))
        );
      });

      // Update total rows for pagination
      this.totalRows = this.filteredData.length;
      this.currentPage = 1;
    },
    clearFilters() {
      // Reset all filter fields
      this.filters = {
        itemName: "",
        type: "",
        supplierName: "",
        categoryName: "",
        subCategoryName: "",
        lowStockValue: "",
        currentStock: ""
      };

      // Reset filtered data to show all items
      this.filteredData = [...this.itemData]; // Create a new copy of the full dataset

      // Reset pagination
      this.totalRows = this.filteredData.length;
      this.currentPage = 1;
    },
    ...mapActions("itemModule", ["addJCByItemIDAction", "addPOByItemIDAction"]),
    ...mapActions("notificationModule", ["getNotificationsAction"]),
    ...mapActions("productModule", ["getProductListAction"]),
    ...mapActions("rawmaterialModule", ["getRawMaterialListAction"]),
    getUpdate(item) {
      return "/rawmaterials/stockTransaction/" + item;
    },
    getCategory(category) {
      if (category) {
        return category;
      } else {
        return "-";
      }
    },
    getSubCategory(subcategory) {
      if (subcategory) {
        return subcategory;
      } else {
        return "-";
      }
    },
    getLowStock(lowStock) {
      if (lowStock) {
        return lowStock;
      } else {
        return 0;
      }
    },
    getCurrentStock(currentStock) {
      if (currentStock) {
        return currentStock;
      } else {
        return 0;
      }
    },
    getPurchaseOrderVariant(itemReorderingType) {
      if (itemReorderingType === "PurchaseOrder") {
        return "primary";
      } else {
        return "secondary";
      }
    },
    isPurchaseOrderDisabled(itemReorderingType) {
      if (itemReorderingType === "JobCard" || itemReorderingType === null) {
        return true;
      } else {
        return false;
      }
    },
    getJobCardVariant(itemReorderingType) {
      if (itemReorderingType === "JobCard") {
        return "primary";
      } else {
        return "secondary";
      }
    },
    isJobCardDisabled(itemReorderingType) {
      if (
        itemReorderingType === "PurchaseOrder" ||
        itemReorderingType === null
      ) {
        return true;
      } else {
        return false;
      }
    },
    handleCheckboxChange(itemId) {
      const index = this.selectedItemIds.indexOf(itemId);
      if (index > -1) {
        this.selectedItemIds.splice(index, 1); // Remove itemId
      } else {
        this.selectedItemIds.push(itemId); // Add itemId
      }
    },
    orderFilterChanged() {
      this.filteredData = this.itemData;

      // Filter by selected category
      if (this.selectedCategory) {
        this.filteredData = this.filteredData.filter((obj) => {
          return obj.categoryID === this.selectedCategory;
        });
      }

      // Filter by selected subcategory
      if (this.selectedSubCategory) {
        this.filteredData = this.filteredData.filter((obj) => {
          return obj.subCategoryID === this.selectedSubCategory;
        });
      }

      if (this.selectedSupplier) {
        this.filteredData = this.filteredData.filter((obj) => {
          return obj.supplierId === this.selectedSupplier;
        });
      }

      // Now, update the itemData with the filtered results
      //this.itemData = this.filteredData;
      //console.log(this.itemData)
      // Update the total rows and reset pagination
      this.totalRows = this.filteredData.length;
      this.currentPage = 1;
    },
    async createPO() {
      try {
        // Redirect to the add purchase order page with selected item IDs in the path
        const itemIds = this.selectedItemIds.join(",");

        if (itemIds == "") {
          this.$swal({
            title: "No items",
            text: "Please select at least 1 item to initiate purchase order",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });

          return;
        }

        this.$router.push({
          name: "purchaseorder-add",
          query: { itemIds: itemIds },
        });
      } catch (error) {
        this.$swal({
          title: "Error!",
          text: "There was an error navigating to the Purchase Order creation page.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },

    async createPurchase(item) {
      try {
        const response = await this.addPOByItemIDAction(item);
        const id = response.id;
        this.$swal({
          title: "Success!",
          text: "Purchase Order created successfully.",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        }).then(() => {
          this.$router.push(`/purchaseorder/view/${id}`);
        });
      } catch (error) {
        this.$swal({
          title: "Error!",
          text: "There was an error creating the Purchase Order.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },
    async createJobCard(item) {
      try {
        const response = await this.addJCByItemIDAction(item);
        const id = response.id;
        this.$swal({
          title: "Success!",
          text: "Job Card created successfully.",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        }).then(() => {
          this.$router.push(`/jobcard/view/${id}`);
        });
      } catch (error) {
        this.$swal({
          title: "Error!",
          text: "There was an error creating the Job Card.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },
    getRawMaterialEdit(item) {
      return "/rawmaterials/edit/" + item;
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      this.filterResults = filteredItems.length == 0 ? false : true;
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  async mounted() {
    await this.getProductListAction(true);
    await this.getNotificationsAction();
    await this.getRawMaterialListAction();
    this.itemData = this.notification.itemList.map((item) => {
      
      if(item.type === 3){
        
        const rawmaterial = this.rawmaterials.find(
          (rawmaterial) => rawmaterial.id === item.itemId);
          console.log('rawmaterial', rawmaterial)
        return {
          ...item,
          itemName: rawmaterial?.name,
          categoryID: rawmaterial?.categoryID,
          categoryName: rawmaterial?.categoryName,
          subCategoryName: rawmaterial?.subCategoryName,
          subCategoryID: rawmaterial?.subCategoryID,
          lowStockValue: rawmaterial?.lowStock,
          supplierName: rawmaterial?.supplierName,
          supplierId: rawmaterial?.supplierId,
        };
      }else{
        const product = this.productList.find(
          (product) => product.id === item.itemId
        );

        return {
          ...item,
          itemName: product?.name,
          categoryID: product?.categoryID,
          categoryName: product?.categoryName,
          subCategoryName: product?.subCategoryName,
          subCategoryID: product?.subCategoryID,
          lowStockValue: product?.lowStock,
          supplierName: product?.supplierName,
          supplierId: product?.supplierId,
        };
      }
    });
    console.log('items', this.itemData)
    this.filterResults = true;
    this.filteredData = this.itemData;
    this.totalRows = this.filteredData.length;
  },
};
</script>
